export function userPictureUrl(picture, getMediaUrl) {
  if (!picture) return '';
  if (/^https?:\/\//i.test(picture) || picture.startsWith('data:') || picture.startsWith('/api/')) {
    return picture;
  }
  return getMediaUrl(picture);
}
